import React, { useReducer } from 'react';
import AuthContext from './authContext';
import AuthReducer from './authReducer';
import { apiCall, setAuthToken, temporaryHeaders } from '../../common/api';
import { response } from '../common';
import {
  USER_LOADED,
  LOGOUT,
  RESPONSE_STATUS,
  COUNT_LOADED,
  CLEAR_RESPONSE,
  CALL_END,
} from './authTypes';
import axios from 'axios';

const AuthState = (props) => {
  const initialState = {
    token: localStorage.getItem('token'),
    isAuthenticated: null,
    isAdmin: null,
    loading: true,
    cartCount: 0,
    user: {},
    responseStatus: null,
    callEnd: null,
  };

  const [state, dispatch] = useReducer(AuthReducer, initialState);
  let resp = new response(dispatch, RESPONSE_STATUS);

  const getAutopilotData = (formData, urlSearchParams, customFields) => {
    const { first_name: FirstName, last_name: LastName, email: Email } = formData;

    const custom = customFields.reduce((fields, { fieldType, name }) => {
      const field = urlSearchParams.get(name.replace(' ', '_').toLowerCase());

      return field ? { ...fields, [`${fieldType}--${name.replace(' ', '--')}`]: field } : fields;
    }, {});

    return {
      contact: {
        FirstName,
        LastName,
        Email,
        custom,
      },
    };
  };

  // Register User
  const register = async (formData, urlSearchParams) => {
    try {
      const autopilotHeaders = {
        autopilotapikey: process.env.REACT_APP_AUTO_PILOT_API_KEY,
        'Content-Type': 'application/json',
      };

      const { data: customFields } = await axios({
        method: 'get',
        url: `${process.env.REACT_APP_AUTO_PILOT_DOMAIN}/contacts/custom_fields`,
        headers: autopilotHeaders,
        transformRequest: [
          (data, headers) => {
            temporaryHeaders.forEach((header) => delete headers.common[header]);
          },
        ],
      });

      const autopilotData = getAutopilotData(formData, urlSearchParams, customFields);

      await axios({
        method: 'post',
        url: `${process.env.REACT_APP_AUTO_PILOT_DOMAIN}/contact`,
        data: autopilotData,
        headers: autopilotHeaders,
        transformRequest: [
          (data, headers) => {
            temporaryHeaders.forEach((header) => delete headers.common[header]);
            return JSON.stringify(data);
          },
        ],
      });

      const [res] = await Promise.all([apiCall('post', 'register', formData, '', 'user')]);

      resp.commonResponse(res.data, 'register');
    } catch (err) {
      resp.commonErrorResponse('register');
    }
  };

  // Check Email User
  const checkValidation = async (formData) => {
    try {
      const [res] = await Promise.all([apiCall('post', 'checkValidation', formData, '', 'user')]);
      resp.commonResponse(res.data, 'checkValidation');
    } catch (err) {
      resp.commonErrorResponse('checkValidation');
    }
  };

  // Login User
  const login = async (formData) => {
    try {
      const [res] = await Promise.all([apiCall('post', 'login', formData, '', 'user')]);
      resp.commonResponse(res.data, 'login');
      if (res.data.status === 'success') {
        localStorage.setItem('token', res.data.data.token);
        loadUser();
      }
    } catch (err) {
      resp.commonErrorResponse('login');
    }
  };

  // Load User
  const loadUser = async () => {
    if (localStorage.token) {
      setAuthToken(localStorage.token);
    }
    const [res] = await Promise.all([apiCall('post', 'validateUser', {}, '', 'user')]);
    if (res.data.status === 'success') {
      await dispatch({
        type: USER_LOADED,
        payload: {
          data: res.data.data.responseData,
        },
      });
    } else if (res.data.status === 'error') {
      await dispatch({
        type: LOGOUT,
      });
    } else {
      await dispatch({
        type: LOGOUT,
      });
    }
    await dispatch({
      type: CALL_END,
      payload: res.data,
    });
  };

  // Load Count
  const loadPendingCount = async () => {
    if (localStorage.token) {
      setAuthToken(localStorage.token);
    }
    const [res] = await Promise.all([apiCall('post', 'pendingCount', {}, '', 'cart')]);
    if (res.data.status === 'success') {
      dispatch({
        type: COUNT_LOADED,
        payload: {
          data: res.data.data.responseData.count,
        },
      });
    }
  };

  // Log out
  const logout = () =>
    dispatch({
      type: LOGOUT,
    });

  // Clear Response
  const clearResponse = () =>
    dispatch({
      type: CLEAR_RESPONSE,
    });

  return (
    <AuthContext.Provider
      value={{
        token: state.token,
        cartCount: state.cartCount,
        isAuthenticated: state.isAuthenticated,
        isAdmin: state.isAdmin,
        loading: state.loading,
        user: state.user,
        responseStatus: state.responseStatus,
        callEnd: state.callEnd,
        register,
        checkValidation,
        login,
        logout,
        loadUser,
        loadPendingCount,
        clearResponse,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthState;
